import App from 'app/app.js';
import 'app/store/ContentStore.js';

function ContentFilter(ContentStore) {
  return function (code) {
    return ContentStore.getContent(null, code);
  };
}

App.filter('ContentFilter', ['ContentStore', ContentFilter]);
